/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-24 15:11:19
 * @LastEditors: K
 * @LastEditTime: 2022-09-07 17:00:24
 */
import { Col } from 'antd';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { TabBar, TabPane } from '../../compnents/widgets/TabBar';
import { NationalPage } from './nationalPage/nationalPage';
import styles from './regulatoryDataTab.module.css'
import { RegulatoryPage } from './regulatoryPage/regulatoryPage';

export const RegulatoryDataTab = () => {
  const location: any = useLocation()

  const [selectedTab, setSelectedTab] = useState('0')
  return (
    <>
      <Col className={styles.container}>
        <TabBar
          activeKey={selectedTab}
          defaultActiveKey={location.state ? location.state.station : '0'}
          destroyInactiveTabPane
          onChange={(v) => {
            setSelectedTab(v)
          }}
        >
          <TabPane key='0' tab='监管数据'>
            <RegulatoryPage />
          </TabPane>
          <TabPane key='1' tab='全国医疗机构数据'>
            <NationalPage />
          </TabPane>

          {/* <TabPane key='2' tab='分析记录'>
            <AnalysisRecordPage />
          </TabPane> */}

        </TabBar>
      </Col>
    </>
  );
}

